import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
private loadingCount = 0;
  private loadingCountSubject = new BehaviorSubject<number>(0);
  
  readonly isLoading$: Observable<boolean> = this.loadingCountSubject.pipe(
    map((count) => count > 0)
  );

  mostrar(): void {
    const currentCount = this.loadingCountSubject.value;
    this.loadingCountSubject.next(currentCount + 1);
  }

  ocultar(): void {
    const currentCount = this.loadingCountSubject.value;
    const newCount = Math.max(0, currentCount - 1);
    this.loadingCountSubject.next(newCount);
  }

  forzarOcultar(): void {
    this.loadingCountSubject.next(0);
  }
}
